import { Tooltip } from "@alpacahq/ui/old";

export const EligibilityCheckTitleTooltip = () => (
  <Tooltip content="Exchanges require us to classify subscribers as Non-Professional or Professional. Algo Trader Plus is currently available only to Non-Professional subscribers. This quick check helps us ensure compliance and keep pricing fair.">
    <p className="m-0 p-0 font-semibold text-gray-700 text-sm leading-5 underline decoration-2 decoration-dotted underline-offset-[3.5px]">
      Why we ask
    </p>
  </Tooltip>
);
